import { useState } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendarWeek,
  faCalendarXmark,
  faChevronRight,
  faGear,
  faMessage,
  faRightFromBracket,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { Button } from "../components/ui/Button";
import { Modal, ModalFooter } from "../components/ui/Modal";

const moreLinks = [
  {
    to: "/settings",
    label: "Settings",
    icon: faGear,
    iconClass: "bg-accent-violet-light text-accent-violet-dark",
  },
  {
    to: "/weekly-schedule",
    label: "Weekly schedule",
    icon: faCalendarWeek,
    iconClass: "bg-brand-100 text-brand-800",
  },
  {
    to: "/disable-dates",
    label: "Disable days",
    icon: faCalendarXmark,
    iconClass: "bg-accent-amber-light text-accent-amber-dark",
  },
  {
    to: "/logs",
    label: "WhatsApp logs",
    icon: faMessage,
    iconClass: "bg-accent-blue-light text-accent-blue-dark",
  },
];

function Menu() {
  const navigate = useNavigate();
  const [logoutModalOpen, setLogoutModalOpen] = useState(false);

  const handleLogout = () => {
    localStorage.clear();
    navigate("/login");
  };

  return (
    <>
      <div className="rounded-xl bg-brand-50 px-4 py-3 text-sm text-content-secondary">
        Schedule settings and WhatsApp logs live here.
      </div>

      <p className="px-1 text-2xs font-semibold uppercase tracking-wider text-brand-600">More</p>
      <div className="overflow-hidden rounded-xl border border-border bg-surface shadow-soft">
        {moreLinks.map((link, index) => (
          <Link
            key={link.to}
            to={link.to}
            className={`flex items-center gap-3 px-4 py-3.5 text-sm font-medium text-content-primary transition-colors hover:bg-brand-50/60${
              index < moreLinks.length - 1 ? " border-b border-border" : ""
            }`}
          >
            <span className={`flex h-8 w-8 items-center justify-center rounded-lg ${link.iconClass}`}>
              <FontAwesomeIcon icon={link.icon} className="text-sm" />
            </span>
            <span className="flex-1">{link.label}</span>
            <FontAwesomeIcon icon={faChevronRight} className="text-xs text-brand-400" />
          </Link>
        ))}
        <button
          type="button"
          onClick={() => setLogoutModalOpen(true)}
          className="flex w-full items-center gap-3 border-t border-border px-4 py-3.5 text-sm font-medium text-accent-rose-dark transition-colors hover:bg-accent-rose-light/60"
        >
          <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-accent-rose-light text-accent-rose-dark">
            <FontAwesomeIcon icon={faRightFromBracket} className="text-sm" />
          </span>
          Sign out
        </button>
      </div>

      <Modal
        open={logoutModalOpen}
        onClose={() => setLogoutModalOpen(false)}
        title="Sign out?"
        footer={
          <ModalFooter>
            <Button variant="secondary" onClick={() => setLogoutModalOpen(false)}>Cancel</Button>
            <Button variant="danger" onClick={handleLogout}>Sign out</Button>
          </ModalFooter>
        }
      />
    </>
  );
}

export default Menu;
